import { render, staticRenderFns } from "./CardTransferSwap.vue?vue&type=template&id=c5c94ea6"
import script from "./CardTransferSwap.js?vue&type=script&lang=js&external"
export * from "./CardTransferSwap.js?vue&type=script&lang=js&external"
import style0 from "./CardTransferSwap.vue?vue&type=style&index=0&id=c5c94ea6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports